import React from 'react';
import { Box } from '@mui/material';

interface TabContentProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const TabContent: React.FC<TabContentProps> = ({
  children,
  value,
  index
}) => {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`student-tabpanel-${index}`}
      aria-labelledby={`student-tab-${index}`}
      sx={{
        display: value === index ? 'block' : 'none',
        flex: 1,
        minHeight: 0
      }}
    >
      {value === index && children}
    </Box>
  );
};